export default {"src":"/_next/static/media/third-place-icon.299eeb89.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};